import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async getDepartmentListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getDepartmentListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Department/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async searchDepartmentByString(query) {
            var meta = { clientApiMethod: 'searchDepartmentByString', input: { query: query } }
            var querystring = encodeURI(query)
            var response = await client().get(store.state.apiRouteRoot + "Department/search?searchQuery=" + querystring, { meta: meta })
            return response.data;
        },
        async getDepartmentById(id) {
            var meta = { clientApiMethod: 'getDepartmentById', input: { id: id } }
            var response = await client().get(store.state.apiRouteRoot + "Department/" + id, { meta: meta })
            return response?.data;
        },
        async createDepartment(newDepartment) {
            var meta = {
                clientApiMethod: 'createDepartment',
                input: { newDepartment },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.department.department") })
            }
            var response = await client().post(store.state.apiRouteRoot + 'Department', newDepartment, { meta: meta })
            return response?.data;
        },
        async updateDepartment(updatedDepartment) {
            var meta = {
                clientApiMethod: 'updateDepartment',
                input: { updatedDepartment },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.department.department") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'Department', updatedDepartment, { meta: meta })
            return response?.data;
        },
    }
}